const ru = {
  100000001:'Ключевая информация',
  100000002:'Название токена',
  100000003:'Создатель копии',
  100000004:'Время создания инстанса',
  100000005:'Основная информация',
  100000006:'Принадлежащая публичная цепочка/протокол',
  100000007:'Адрес смарт-контракта',
  100000008:'Дата выпуска',
  100000009:'Общая поставка',
  100000010:'Круговая поставка',
  100000011:'Рыночная стоимость',
  100000012:'Информация',
  100000013:'Информация в социальных сетях',
  100000014:'Веб-сайт',
  100000015:'Белая книга',
  100000016:'Браузер блокчейна',
  100000017:'Оценка проекта',
  100000018:'Рейтинг',
  100000019:'Топ ',
  100000020:'Code security',
  100000021:'Operation Performance',
  100000022:'Market Stability',
  100000023:'Governance Strength',
  100000024:'Project Health',
  100000025:'Community Trust',
  100000026:'Время обновлено',
  100000027:'Оценка безопасности',
  100000028:'Оценка безопасности контракта',
  100000029:'Статистика рисковых проектов',
  100000030:'Детали кода контракта',
  100000031:'Налог на покупку',
  100000032:'Налог на продажу',
  100000033:'Это ловушка?',
  100000034:'Можно ли повторно чеканить',
  100000035:'Есть ли черный список',
  100000036:'Есть ли белый список',
  100000037:'Есть ли защита от китов',
  100000038:'Можно ли изменить налоговую ставку',
  100000039:'Является ли это открытым исходным кодом',
  100000040:'Есть ли скрытые держатели',
  100000041:'Можно ли самоуничтожиться',
  100000042:'Является ли это прокси-контрактом',
  100000043:'Можно ли изменить баланс',
  100000044:'Можно ли выполнить внешний вызов',
  100000045:'Можно ли восстановить право собственности',
  100000046:'Существует ли период охлаждения для сделок',
  100000047:'Можно ли приостановить перевод',
  100000048:'Право собственности не отказано  ',
  100000049:'Является ли это регулируемым анти-китом  ',
  100000050:'Слишком много десятичных знаков  ',
  100000051:'Публичные методы Mint и Burn  ',
  100000052:'Обновляет ли сжигание токенов общий объём  ',
  100000053:'Обновляет ли сжигание токенов баланс  ',
  100000054:'Увеличивается ли баланс при самопереводе   ',
  100000055:'Будет ли недействительной транзакция на сумму',
  100000056:'Баланс не обновлён при переводе  ',
  100000057:'Будет ли потребляться баланс получателя  ',
  100000058:' Будет ли вызов TransferFrom неудачным',
  100000059:'Будет ли метод BurnFrom обновлять общее количество',
  100000060:'Определите налог на покупку токена. Выше 5% считается высокой налоговой ставкой',
  100000061:'Определите налог на продажу токена. Выше 5% считается высокой налоговой ставкой',
  100000062:'Проверьте, является ли токен мошенничеством с ловушкой (honeypot)',
  100000063:'Проверьте, можно ли выпустить больше токенов',
  100000064:'Проверьте, есть ли у токена черный список, который может ограничивать пользователей в обмене или переводе токенов',
  100000065:'Проверьте, есть ли у токена белый список, который позволяет адресам обходить любые ограничения',
  100000066:'Проверьте, есть ли у токена механизмы против крупных владельцев (анти-«кит»)',
  100000067:'Проверьте, есть ли у токена налог и может ли он быть изменен привилегированными ролями',
  100000068:'Проверьте, был ли токен проверен на блокчейн-обозревателе',
  100000069:'Проверьте, есть ли у токена скрытый владелец, который может манипулировать контрактом, даже если права собственности, кажется, были отреклись',
  100000070:'Проверьте, может ли токен самоуничтожиться',
  100000071:'Проверьте, является ли токен прокси-контрактом, который делегирует вызовы функций контракту-реализации',
  100000072:'Проверьте, может ли баланс токена быть изменен привилегированными ролями',
  100000073:'Проверьте, вызывает ли токен внешние контракты',
  100000074:'Проверьте, есть ли у токена лазейка для восстановления владения',
  100000075:'Проверьте, есть ли у токена механизм задержки передачи',
  100000076:'Проверьте, может ли торговля токеном быть приостановлена привилегированными ролями',
  100000077:'Проверьте, было ли отречено от привилегий владельца',
  100000078:'Проверьте, могут ли механизмы против крупных владельцев токена быть изменены привилегированными ролями',
  100000079:'Проверьте, больше или равно ли значение, возвращаемое функцией decimals(), 5',
  100000080:'Проверьте, будет ли откат при вызове функций mint() и burn() обычными пользователями',
  100000081:'Проверьте, будет ли корректно обновлено totalSupply при вызове функции burn()',
  100000082:"Проверьте, будет ли корректно обновлено разрешение при вызове функции burnFrom()",
  100000083:'Проверьте, увеличится ли баланс отправителя при вызове функции transfer() с получателем, который совпадает с отправителем транзакции',
  100000084:'Проверьте, завершится ли неудачей вызов функции transfer() с суммой, превышающей баланс',
  100000085:"Проверьте, обновляется ли разрешение тратящего соответственно после вызова функции transferFrom()",
  100000086:"Проверьте, будет ли использоваться баланс тратящего при вызове функции transferFrom()",
  100000087:"Проверьте, обновляется ли разрешение правильно после вызова transferFrom() или транзакция откатывается, если сумма недействительна.",
  100000088:"Проверьте, обновляется ли totalSupply правильно при вызове функции burnFrom()",
  100000089:'Проверьте, существует ли полномочие на выпуск токенов',
  100000090:'Проверьте, существует ли полномочие на заморозку',
  100000091:'Проверьте, можно ли изменить метаданные',
  100000092:'Критический',
  100000093:'Серьёзный',
  100000094:'Средний',
  100000095:'Незначительный',
  100000096:'Информационный',
  100000097:' Отказались ли от права чеканки',
  100000098:' Отказались ли от права заморозки',
  100000099:' Можно ли изменить метаданные токена',

  100000100:'Ваш годовой отчет генерируется…',
  100000101:'Добро пожаловат',
  100000102:'Ваш обзор 2024 год',
  100000103:'Я Ваше личное руководство',
  100000104:'Здесь, чтобы провести вас по следам вашего путешествия в 2024 году',
  100000105:'Открыть отчет',
  100000106:'{num} дней назад колеса судьбы начали вращаться.',
  100000107:'{userName} Наша история начинается здесь',
  100000108:'Вместе мы шли к общей мечте.',
  100000109:'Инвестиционные звезды',
  100000110:'Обзор кошелька – общая годовая доходность',
  100000111:'Вы опережаете <em class="normal bold" style="color: #2AFF0A;">{percentage}</em> пользователей',
  100000112:'За последний год мы испытали <em class="normal bold" style="color: #FFF;">FOMO</em>, вызванный надписями, и наслаждались радостью от <em class="normal bold" style="color: #FFF;">meme роста</em>. Теперь давайте вместе погрузимся в ваши воспоминания.',
  100000113:'Звездный трейдер',
  100000114:'Совокупное количество транзакций в 2024 году (раз)',
  100000115:'Совокупная сумма транзакции ($)',
  100000116:'Вы превзошли <em class="normal bold" style="color: #FFC72B;">{percentage}%</em> пользователей.',
  100000117:'Это не просто численное достижение, но и знак вашего видения и мудрости.',
  100000118:'Каждая сделка — это шаг к Web3.0.',
  100000119:'Восходящая звезда',
  100000120:'Наибольшее падение биткоина в 2024 году достигло <em class="normal">34%</em>. Коррекция рынка – это норма, а эффективность ваших инвестиций – это всего лишь этап: впереди вас ждет огромный потенциал!',
  100000121:'Стабильный инвестор',
  100000122:'Каждое наблюдение и ожидание были подготовкой к более конкретному моменту. Мы с нетерпением ждем чудес от ваших инвестиций и прибыли в 2025 году.',
  100000123:'Токен, который торговался больше всех  в 2024 году',
  100000124:'То, что вы держите, отзовется эхом',
  100000125:'Ваше внимание и усилия уже отразились на результатах вашей торговли.',
  100000126:'Эффективность Биткоина на SuperEx в 2024 году',
  100000127:'2024 год ваша волатильность Bitcoin',
  100000128:'Поздравляем с увеличением ваших активов! Продолжайте в том же духе в наступающем году.',
  100000129:'В 2024 году у вас не было биткоинов.',
  100000130:'Выдающийся инвестор',
  100000131:'Стабильный инвестор',
  100000132:'Обучающийся инвестор',
  100000133:'Ваши торговые данные на основном рынке',
  100000134:'доход($)',
  100000135:'Годовая доходность (%)',
  100000136:'Рейтинг прибыли (%)',
  100000137:'Ваши торговые данные контрактами',
  100000138:'Ваша торговая стратегия демонстрирует вашу мудрость — спасибо, что выбрали сотрудничество с нами!',
  100000139:'Отправляясь в будущее',
  100000140:'Вы не только следите за модой, но и являетесь ее пионером! Вы выпустили монеты в свободной зоне <em class="normal bold" style="color: #FFF;">{num1}</em> раз и совершили <em class="normal bold" style="color: #FFF;">{num2}</em> сделок. Вы, кто любит инновационные продукты, настоящий искатель приключений!',
  100000141:'Супер социальная звезда',
  100000142:'Благодарим вас за то, что вы привели <em class="normal bold" style="color: #FFF;">{num}</em> новых пользователей на нашу платформу. Ваши рекомендации способствовали нашему росту. Мы с нетерпением ждем, когда еще больше единомышленников присоединятся к нам в путешествии по Web3.0.',
  100000143:'Восходящая звезда соцсетей',
  100000144:'<em class="normal bold" style="color: #FFF;">{num}</em> пользователь SuperEx заработали до 40% торговых комиссий, приглашая друзей. Если вы пропустили 2024 год, не волнуйтесь — воспользуйтесь шансом в 2025 году.',
  100000145:'Поделитесь своими годовыми достижениями со своим сообществом, предложите большему количеству людей присоединиться к нам и разблокируйте эксклюзивные награды, вместе исследуя мир криптовалют!',
  100000146:'Пригласите друга и получите награду в размере 10 USDT!',
  100000147:'Поделиться отчетом',
  100000148:'Посмотреть еще раз',
  100000149:'В 2024 году на SuperEx вас знали как',
  100000150:'Вы превзошли пользователей платформы:',
  100000151:'Основной рынок Спотовая торговля =Годовая доходность',
  100000152:'Контракт Годовая доходность',
  100000153:'В этом году я — инвестиционная легенда!',
  100000154:'Реферальный код: {InviteCode}',
  100000155:'SuperEx.com - Web3.0 криптовалютная биржа',
  100000156:'Стабильные победы, сила раскрыта!',
  100000157:'В этом году накоплен опыт; следующий год будет еще лучше!',
  100000158:'Вы знали?',
  100000159:'СуперЭкса свободная зона спотовой торговли - самая горячая и перспективная платформа для торговли Meme-койнами в мире.',
  100000160:'2024, SuperEx добавляет новых <em class="normal bold" style="color: #FFF;">{num}</em> пользователей, как новую семью',
  100000161:'Ваш обзор 2024 года и путешествие к тысячекратной прибыли в 2025 году вот-вот начнется.',
  100000162:'Это письмо от опытного члена семьи Superex, в котором записаны их радостные новости на 2024 год.',
  100000163:'@to*** успешно купил 1 BTC за 1 USDT, доходность составила <em class="normal bold" style="color: #FFF;font-size:0.7rem">9,958,800%</em>.',
  100000164:'@1o*** получил 1 ETH за 1 USDT, доходность составила <em class="normal bold" style="color: #FFF;font-size:0.7rem">487,000%</em>.',
  100000165:'@we*** получил 1 iPhone 15 за 1 USDT, доходность <em class="normal bold" style="color: #FFF;font-size:0.7rem">92,800%</em>.',
  100000166:'Есть еще больше интересного…',
  100000167:'Небольшие вложения, большие возвраты и постоянно обновляющийся геймплей делают каждое участие полным неожиданностей!',
  100000168:'Спот, контракт, управление капиталом…',
  100000169:'Письмо длинное, давайте продолжим читать',
  100000170:'Суммарный выпуск токенов более <span class="inline-block relative bold" style="color: #FFFFFF;font-size:1rem">150+</span>, SuperEx продолжит стремиться создавать больше возможностей для пользователей.',
  100000171:'Годовой обзор кошелька Счет накопленная доходность',
  100000172:'Обзор кошелька Счет Годовая прибыль и убыток <em class="normal bold {classNum}">{num}</em>',
  100000173:'Вы опережаете <em class="normal bold" style="color: #FFF;font-size:1rem">{percentage}%</em> пользователей. Ваша мудрость в инвестиционных стратегиях потрясающа.',
  100000174:'2025-SuperEx',
  100000175:'Путь к богатству',
  100000176:'Когда будете готовы',
  100000177:'Привет! Я новый друг SuperEx.',
  100000178:'Присоединяйтесь к SuperEx и откройте для себя бесконечные возможности. Зарегистрируйтесь и получите преимущества для новых пользователей.',
  100000179:'Пользователь @vb*** участвует в торговле на спотовой главной площадке, cumulative доходность по $ATOM составляет почти <em class="normal bold" style="color: #FFF;font-size:0.7rem">10,400%</em>.',
  100000180:'Пользователь @xi*** участвует в спотовой торговле на основном рынке, кумулятивная доходность $PIPE почти <em class="normal bold" style="color: #FFF;font-size:0.7rem">7,400%</em>.',
  100000181:'Пользователь @09*** участвует в спотовой основной торговле $ATH, накопленная доходность почти <em class="normal bold" style="color: #FFF;font-size:0.7rem">3,500%</em>.',
  100000182:'Мы с нетерпением ждем, когда увидим вашу первую сделку на WEB3 и начнем увлекательную главу!',
  100000183:'1USD, Super Start, спот 1000+, кредитное плечо 150X, надпись 1000X…',
  100000184:'Испытайте различные высокодоходные сектора!',
  100000185:'Рост и падение временны, но вера вечна.',
  100000186:'Пройдя через волатильность, вы станете свидетелем истинной ценности.',
  100000187:'Ваш отчет за 2024 год еще не создан. Добро пожаловать в новое торговое путешествие! Накопите больше активности, чтобы разблокировать персонализированный итог в следующем году!',
  100000188:'Ежегодная история криптовалют за 2024 год ждет вас! Переживите самые яркие моменты 2024 года вместе с SuperEx, приходите и поделитесь своими эксклюзивными моментами! ',
  100000189:'Ежегодная история криптовалют за 2024 год ждет вас!',
  100000190: 'Откройте приложение SuperEx, чтобы просмотреть “Годовой отчет”.',
  100000191: '{year}год {month}месяц {day}день (UTC)',
  100000192: 'Покупатель',
  100000193: 'Код заказа',
  100000194: 'Я',
  100000195: 'Список участников',
  100000196: 'Цифровые валютные товары выданы. Для получения физических товаров обратитесь в службу поддержки',
  100000197: 'Покупка успешна',
  100000198: '{name}успешно получено',
  100000199: 'Купите',
  100000200: 'Все загружено',
  100000201: 'Поздравляем {name} с выигрышем {shop}!',
  100000202: 'Пользователь {name} успешно присоединился к {shop}!'

}
export default ru


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/ru.js